import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import type { ComposeComponentRichTextCtaFragment } from '../../../.graphql/generated-types'
import { ContentfulRichText } from '../../components/ContentfulRichText'
import { CTAButton } from '../CTAButton'

export interface ComposeComponentRichTextCTAProps {
  data: ComposeComponentRichTextCtaFragment
}

export function ComposeComponentRichTextCTA({
  data,
}: ComposeComponentRichTextCTAProps) {
  if (data.text?.json && data.link) {
    return (
      <div className="flex flex-col space-y-4 rounded border-2 border-blog-purply-pink-300 p-6 md:flex-row md:space-x-4 md:space-y-0">
        <div className="flex-grow">
          <style global jsx>{`
            h2 {
              margin-bottom: 1rem;
            }
          `}</style>
          <ContentfulRichText
            document={data.text.json as Document}
            entries={data.text.links.entries}
          />
        </div>
        <CTAButton data={data.link} />
      </div>
    )
  }
  return null
}
